import { render, staticRenderFns } from "./ImportMailAddress.vue?vue&type=template&id=23b33198&scoped=true&"
import script from "./ImportMailAddress.vue?vue&type=script&lang=js&"
export * from "./ImportMailAddress.vue?vue&type=script&lang=js&"
import style0 from "./ImportMailAddress.vue?vue&type=style&index=0&id=23b33198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b33198",
  null
  
)

export default component.exports